import { render, staticRenderFns } from "./QuestionnaireAnswerOptionSelector.vue?vue&type=template&id=6da67228&scoped=true&"
import script from "./QuestionnaireAnswerOptionSelector.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireAnswerOptionSelector.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireAnswerOptionSelector.vue?vue&type=style&index=0&id=6da67228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da67228",
  null
  
)

export default component.exports